import React, { Component, Fragment } from "react";
import { Col, Row } from 'reactstrap';
import { withStyles } from "@material-ui/core/styles";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import { KeyboardDatePicker, DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import Modal from '@material-ui/core/Modal';
import DataReactTable from '../MedicalOrders/DataReactTable';
import ReactTableActionsMedics from '../MedicalOrders/ReacTableActionsMedics';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import moment from 'moment';
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';

const MedicalRadio = withStyles({
    root: {
        color: '#4CE1B6',
        '&$checked': {
            color: '#4CE1B6',
        },
    },
    checked: {},
})((props) => <Radio color="default" {...props} />);


const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },

    },
});

class Inmunizations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sectionAilment: {},
            showCommentaties: [],
            commentaries: [],
            openMedicaments: false,
            loadMedicaments: true,
            useMediTable: false,
            medicament: [],
            dataMedicaments: [],
            openModal: false,
            load: true,
            dataDiagnostic: [],
            diagnostic: [],
            showTable: true,
            vacuna: "",
            principioactivo: "",
            concentracion: "",
            viaadministracion: "",
            observation: "",
            frecuencia: "",
            dateStart: null,
            dateEnd: null,
            firstCharge: false,
            dateDosis: null,
            errors: {}
        }
    }

    handlerDate = (date) => {
        let checkDate= this.validateDate(date)
        if(checkDate){
            this.setState({ dateDosis: date });
        }
    }

    validateDate = (date) =>{
        var errors = this.state.errors;
        let error = false;
        let regExToTest = /^((0?[0-9]|1[012])[- \/.](0?[0-9]|[12][0-9]|3[01])[- \/.](19|20)?[0-9]{2})*$/;
        let resTest = !regExToTest.test(date);
        console.log('regExToTest', resTest);
        if (!regExToTest.test(date)) {
            errors.fecha = "Ingrese un formato de fecha";
            error = true
        } else {
            errors.fecha = "";
        }
        this.setState({ errors });
        return error
    }

    render() {
        const row = {};

        return (
            <Fragment>
                <Row>
                    <div className="element-question-background">
                        <div className="question-background">
                            <FormControl component="fieldset" >
                                <FormLabel style={{ color: 'black' }} disabled={true}>Inmunizaciones</FormLabel>
                                <RadioGroup
                                    onChange={(e) => {
                                        this.props.handlerInmunizationsBackgroundRadio(e.target.value, 'inmunizaciones');
                                    }}
                                    row aria-label="position"
                                    id="radio-inmunizations-inmunizaciones"
                                    name="radio-inmunizations-inmunizaciones"
                                    value={this.props.sectionAilment.inmunizations.inmunizaciones.value}>
                                    <FormControlLabel value="Si" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="Si" />
                                    <FormControlLabel value="No" control={<MedicalRadio disabled={this.props.stateClinicHistory} />} label="No" />
                                </RadioGroup>
                            </FormControl>

                            {/* <div className="answer-background">
                                <TextField
                                    label=""
                                    disabled={this.props.sectionAilment.inmunizations.inmunizaciones.value == "No" || this.props.stateClinicHistory == true ? true : false}
                                    value={this.props.sectionAilment.inmunizations.inmunizaciones.comentario}
                                    onChange={(e) => {
                                        this.props.handlerInmunizationsBackgroundText(e.target.value, 'inmunizaciones');
                                    }}
                                    style={{ minWidth: '100%', maxWidth: '100%' }}
                                    className="medical-material-form__field"
                                    InputLabelProps={{
                                        //style: { color: '#646777' }
                                    }}
                                />
                            </div> */}
                        </div>
                        {
                            this.props.sectionAilment.inmunizations.inmunizaciones.value == 'Si' ?
                                <div>
                                    <table className="table table--bordered" >
                                        <thead>
                                            <tr>
                                                <td >Vacuna </td>
                                                <td >Fecha de aplicación</td>
                                                <td ></td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <TextField
                                                        type="text"
                                                        className="table-medice-fields"
                                                        disabled={this.props.stateClinicHistory}
                                                        value={this.state.vacuna}
                                                        onChange={(e) => {
                                                            this.setState({ vacuna: e.target.value });
                                                        }}
                                                    />
                                                </td>
                                                {/* <td>
                                                    <TextField
                                                        type="text"
                                                        className="table-medice-fields"
                                                        disabled={this.props.stateClinicHistory}
                                                        value={this.state.dateDosis}
                                                        onChange={(e) => {
                                                            this.handlerDate(e.target.value)
                                                        }}
                                                        error={this.state.errors.hasOwnProperty("fecha") ? this.state.errors.fecha !== "" : false}
                                                        helperText={this.state.errors.fecha}
                                                    />
                                                </td> */}
                                                 <td>
                                                    <MuiPickersUtilsProvider utils={MomentUtils} >
                                                        <ThemeProvider theme={defaultMaterialTheme}>
                                                            <KeyboardDatePicker
                                                                style={{ marginLeft: '1em' }}
                                                                autoOk
                                                                disabled={this.props.stateClinicHistory}
                                                                disableFuture
                                                                className="table-medice-fields"
                                                                format="DD-MM-YYYY"
                                                                variant="inline"
                                                                animateYearScrolling
                                                                value={this.state.dateDosis}
                                                                onChange={(date) => {
                                                                    this.setState({ dateDosis: date });
                                                                }}
                                                            />
                                                        </ThemeProvider>
                                                    </MuiPickersUtilsProvider>
                                                </td>
                                                <td>
                                                    <Tooltip title="Agregar"
                                                        disabled={this.props.stateClinicHistory}
                                                    >
                                                        <IconButton
                                                            color="primary"
                                                            onClick={() => {
                                                                if (this.state.vacuna != null) {
                                                                    row.vacuna = this.state.vacuna;
                                                                    row.fecha = this.state.dateDosis != null ? moment(this.state.dateDosis).format('YYYY-MM-DD') : null
                                                                    this.props.handlerInmunizationsBackgroundTableAdd('inmunizaciones', row);
                                                                    this.setState({ showTable: true });
                                                                    this.setState({ vacuna: "", dateDosis: null });
                                                                }
                                                            }}>
                                                            <span className="lnr lnr-plus-circle" style={{ margin: 'auto', fontSize: 20 }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </td>
                                            </tr>
                                            {this.state.showTable ?
                                                this.props.sectionAilment.inmunizations.inmunizaciones.table.map((data, num) => {
                                                    return <tr key={num}>
                                                        <td>{data.vacuna}</td>
                                                        <td>{data.fecha}</td>
                                                        <td>
                                                            <Tooltip title="Quitar"
                                                                disabled={this.props.stateClinicHistory}
                                                            >
                                                                <IconButton
                                                                    color="primary"
                                                                    onClick={() => {
                                                                        this.props.handlerInmunizationsBackgroundTableDelete('inmunizaciones', num);
                                                                        this.setState({ showTable: true });
                                                                    }}>
                                                                    <span className="lnr lnr-trash" style={{ margin: 'auto', fontSize: 20 }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </td>
                                                    </tr>
                                                })
                                                : null}
                                        </tbody>
                                    </table>
                                </div>
                                : null
                        }
                    </div>
                </Row>
                <Row>
                    <div className="form">
                        <span className="form__form-group-label" style={{ marginRight: 10, width: 150 }}>Observaciones</span>
                        <div className="form__form-group-field">
                            <textarea
                                id="textarea-observation"
                                value={this.props.sectionAilment.inmunizations.observacion}
                                disabled={this.props.stateClinicHistory}
                                name="textarea-surgical"
                                onChange={(e) => {
                                    this.props.handlerInmunizationsBackgroundObservation(e.target.value, 'observacion');
                                }}
                            >
                            </textarea>
                        </div>
                    </div>
                </Row>
            </Fragment>

        );
    }
}

export default Inmunizations;
